<div class="loading"></div>
<ion-router-outlet></ion-router-outlet>
